import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {BaseTypedValueType, TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import getTestProps from 'test/lib/cypress/getTestProps';
import BenchChip from 'ui-library/chips/BenchChip';
import {ChipSize} from 'ui-library/chips/Chip';

interface FillPlateTransferSourceSchemaChipProps {
  typedValue: TypedValue;
}

export default function FillPlateTransferSourceSchemaChip({
  typedValue,
}: FillPlateTransferSourceSchemaChipProps): JSX.Element | null {
  if (typedValue.type === BaseTypedValueType.JSON) {
    const {apiId, displayNameOverride, schemaColor} = typedValue.jsonValue;
    if (apiId != null && schemaColor != null && displayNameOverride != null) {
      return (
        <div className={css(styles.wrapper)}>
          <div
            className={css(styles.swatch)}
            style={{backgroundColor: schemaColor}}
            {...getTestProps({component: 'FillPlateTransferSourceSchemaChip', element: 'swatch'})}
          />
          <BenchChip
            size={ChipSize.TABLE_CELL}
            id={apiId}
            displayNameOverride={displayNameOverride}
            isLink={false}
          />
        </div>
      );
    }
  }
  return null;
}

const styles = StyleSheet.create({
  emptyWell: {
    fontStyle: 'italic',
  },
  wrapper: {
    display: 'flex',
  },
  swatch: {
    width: '4px',
    marginRight: '4px',
    flex: '0 0 4px',
  },
});
